var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.7 19.3 6.6-6.6q.15-.15.212-.325.063-.176.062-.375 0-.2-.062-.375a.9.9 0 0 0-.213-.325l-6.6-6.6a.98.98 0 0 0-.687-.288.93.93 0 0 0-.713.288.94.94 0 0 0-.313.687.93.93 0 0 0 .288.713l4.9 4.9H5a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 12q0 .424.287.712Q4.574 13 5 13h11.175l-4.9 4.9a1 1 0 0 0-.288.7.87.87 0 0 0 .288.7q.276.3.7.3.425 0 .725-.3"
  })));
};
export { SvgArrowRight as ReactComponent };